export default class Service {

	static get $inject(){
		return ['$rootScope', '$timeout'
			, 'AppSettingsService', 'gettext', 'LanguageService'];
	}

	constructor($rootScope, $timeout,
	            AppSettingsService, gettext, LanguageService){

		this._$timeout = $timeout;
		this._$rootScope = $rootScope;
		this._NotificationSettings = AppSettingsService.notifications;
		this.LanguageService = LanguageService;
		this.MESSAGES = [
			gettext('Invalid credentials given.'),
			gettext('Error'),
		];
		this._$rootScope.alerts = [];
		this._$rootScope.closeAlert = (index)=>{
			this._$rootScope.alerts.splice(index, 1);
		};
		this.messageNum = 0;
	}


	add(msg, type){
		let id = this.messageNum++;

		type = type || 'danger';
		msg = msg && msg.data && msg.data.message ? msg.data.message : typeof msg === 'string' ? msg : 'An error has occurred';

		this._$rootScope.alerts.push({ type: type, msg: this.getTranslatableText(msg), id: id });

		this._$timeout(()=>{
			this._$rootScope.closeAlert(this._$rootScope.alerts.find(v=>v.id === id));
		}, this._NotificationSettings.delaySeconds * 1000);

	}

	reset(){
		this._$rootScope.alerts = [];
	}

    getTranslatableText(text) {

        return this.LanguageService.getTranslatableText(text)

    }


}

//{ type: 'danger', msg: 'Oh snap! Change a few things up and try submitting again.' },
//{ type: 'success', msg: 'Well done! You successfully read this important alert message.' }


/** WEBPACK FOOTER **
 ** ./src/services/app/alerts.service.js
 **/